// extracted by mini-css-extract-plugin
module.exports = {"section":"section-module--section--3Erd5","green":"section-module--green--sPXQF","black":"section-module--black--2pgpT"};